import React, {Component} from 'react';
import Menu from "../Menu";
import PageHeader from "../PageHeader";
import GlobalVariable from "../../GlobalVariable";
import api from "../../api";
import axios from "axios";
import {number} from "@amcharts/amcharts4/core";

interface Styles {
    [key: string]: React.CSSProperties;
}

export class StaffOffer extends Component <any, any> {
    constructor(props: any) {
        super(props);window.scrollTo(0, 0);
        this.state = {
            showBlock: false,
            showBlockMonth: false,
            activeAddress: 'Загружаем адрес',
            activeMonth: 'Загружаем месяц',
            activeAddressId: null,
            activeMonthApi: null,
            dayMonth: [],

            staffSchedule: [],
            monthArrayName: [],
            timePeriod: [{id: 1, from: '10:00', to: '20:00', onlineRecord: true}],
            AddressArray: [],
            activeDay: [],
            isOpenChooseTime: false,
            SettingScheduleYourself: false,
            SettingScheduleAll: false,
        };

    }




    render() {
        const styles: Styles = {
            container: {
                fontFamily: 'Arial, sans-serif',
                maxWidth: '800px',
                margin: '0 auto',
                padding: '20px',
                color: '#333',
            },
            title: {
                color: '#E52138',
                textAlign: 'center',
                marginBottom: '30px',
            },
            offer: {
                border: '1px solid #e0e0e0',
                borderRadius: '10px',
                padding: '20px',
                marginBottom: '30px',
                boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
                textAlign: 'center',
            },
            offerTitle: {

                marginTop: '0',
            },
            bonus: {
                fontSize: '18px',
                fontWeight: 'bold',
                color: '#E52138',
                margin: '10px 0',
            },
            button: {
                display: 'inline-block',
                backgroundColor: '#E52138',
                color: 'white',
                padding: '12px 24px',
                textDecoration: 'none',
                borderRadius: '5px',
                fontWeight: 'bold',
                marginTop: '15px',
                margin:' auto',
                transition: 'background-color 0.3s',
                border: 'none',
                cursor: 'pointer',
            },
            buttonContainer: {
                display: 'flex',
                justifyContent: 'center', // Центрируем кнопку
                marginTop: '15px',
            },
        };

        return (
            <div className='main schedule'>
                <div className='content mx-w-content  position-relative'>
                    <PageHeader
                        pageTitle='Привести друга'
                        backBtnUrl='/'/>

                    <div className='pt-header'></div>
                    <h1 style={{textAlign:'center'}}>Специальне предложение</h1>

                    <div style={styles.container}>


                        <div style={styles.offer}>
                            <h2 style={styles.offerTitle}>1. Привести друга</h2>
                            <p>Кто-то из твоих друзей хочет открыть свой бизнес? Рекомендуй ему франшизу Чио Чио!</p>
                            <div style={styles.bonus}>Твой бонус: 50 000 рублей</div>
                            <div style={styles.bonus}>Друг получит скидку: 50 000 рублей</div>
                            <div style={styles.buttonContainer}>
                                <a href={'https://forms.amocrm.ru/rwrzxcw'}><button style={styles.button}>Рекомендовать друга</button></a>

                            </div>
                        </div>

                        <div style={styles.offer}>
                            <h2 style={styles.offerTitle}>2. Привести друга</h2>
                            <p>Есть друг с собственной парикмахерской? Сделай ему подарок!</p>
                            <div style={styles.bonus}>Твой бонус: 20 000 рублей</div>
                            <div style={styles.bonus}>Друг присоединится БЕСПЛАТНО</div>
                            <div style={styles.buttonContainer}>
                                <a href={'https://forms.amocrm.ru/rwrzxcw'}><button style={styles.button}>Рекомендовать друга</button></a>

                            </div>
                        </div>
                    </div>


                </div>
                <Menu></Menu>
            </div>
        )
    }
}


export default StaffOffer;